module.exports = __webpack_public_path__ + "img/xy_gs_w.67a4ce0.png";